import { render } from 'react-dom';
import './auto-drag-model.less';
import classNames from 'classnames';
import React, { useEffect, useRef } from 'react';
import { useMoveEventListener } from '@/hooks/use-move-event-listener';

export interface IAutoDragModalProps {
    // 初始位置
    initPosition?: { x: number; y: number };

    // 窗口大小
    windowSize?: { width: number; height: number };

    // 背后是否可操作
    bgCanOperate?: boolean;

    children: React.ReactNode;

    className?: string;

    id?: string;
}

const AutoDragModalContainer: React.FC<IAutoDragModalProps> = ({
    children,
    initPosition,
    windowSize,
    bgCanOperate = false,
    className,
}) => {
    const currentPositionRef = useRef({
        x: initPosition ? initPosition.x : 0,
        y: initPosition ? initPosition.y : 0,
    });

    const windowSizeRef = useRef({
        width: windowSize ? windowSize.width : 100,
        height: windowSize ? windowSize.height : 100,
    });

    useEffect(() => {
        const elem = document.getElementById('inputDataTemplateContent');

        if (!elem) {
            return;
        }

        elem.style.left = `${currentPositionRef.current.x}px`;
        elem.style.top = `${currentPositionRef.current.y}px`;
    }, []);

    useMoveEventListener((e) => {
        const target = e.target;

        if (!e.target) {
            return;
        }

        // 可移动区域元素要加data-type = canDrag
        if (target.getAttribute('data-operate-type') !== 'canDrag') {
            return;
        }
        e.originEvent.preventDefault();
        e.originEvent.stopPropagation();
        let newValueX = currentPositionRef.current.x + e.deltaX;
        let newValueY = currentPositionRef.current.y + e.deltaY;

        if (newValueX < -(windowSizeRef.current.width - 50)) {
            newValueX = -(windowSizeRef.current.width - 50);
        } else if (newValueX > window.innerWidth - 50) {
            newValueX = window.innerWidth - 50;
        }

        if (newValueY < -(windowSizeRef.current.height - 50)) {
            newValueY = -(windowSizeRef.current.height - 50);
        } else if (newValueY > window.innerHeight - 50) {
            newValueY = window.innerHeight - 50;
        }
        currentPositionRef.current.x = newValueX;
        currentPositionRef.current.y = newValueY;

        const elem = document.getElementById('inputDataTemplateContent');

        if (!elem) {
            return;
        }

        elem.style.left = `${currentPositionRef.current.x}px`;
        elem.style.top = `${currentPositionRef.current.y}px`;
    });

    return (
        <div
            className={classNames({
                [className || '']: true,
                'c-input-data-template-warp': true,
            })}
            style={{
                pointerEvents: bgCanOperate ? 'none' : 'auto',
            }}
        >
            <div
                className="c-input-data-template-mask"
                style={{
                    pointerEvents: bgCanOperate ? 'none' : 'auto',
                }}
            ></div>
            <div
                className="c-input-data-template-content"
                id="inputDataTemplateContent"
                style={{
                    width: `${windowSizeRef.current.width}px`,
                    height: `${windowSizeRef.current.height}px`,
                }}
            >
                {children}
            </div>
        </div>
    );
};

export default AutoDragModalContainer;

const id = 'input-template-data-modal';
export class AutoDragModal {
    static show(params: IAutoDragModalProps) {
        const useId = params.id ? params.id : id;
        if (!document.getElementById(useId)) {
            const el = document.createElement('div');
            el.className = useId;
            el.id = useId;
            document.body.appendChild(el);
        }

        render(<AutoDragModalContainer {...params} />, document.getElementById(useId) as HTMLElement);
    }

    static close(modelId?: string) {
        if (!document.getElementById(modelId ? modelId : id)) {
            return;
        }
        render(<div></div>, document.getElementById(modelId ? modelId : id) as HTMLElement);
    }
}
